module.exports = __webpack_public_path__ + "static/media/chassis-number.622e88e2.svg";